import React from "react";
import Visualisation from "./Visualisation";
import BenchmarkingTabs from "./BenchmarkingTabs";
import { usePublic } from "helpers/utlities";

const Benchmarking = ({alert}) => {
  
  if(usePublic()){
    return <Visualisation alert={alert}/>
  }else{
    return  <BenchmarkingTabs alert={alert}/>
  }
}

export default Benchmarking
